import { accountPasswordLogin, smsCodeLogin, setDocType, logingout, updateUserInfo } from '@/api/user'
import router from '@/router'
import Vue from 'vue'
import { Message } from 'element-ui'

const state = {
  code: '',
  userid: '',
  username: '',
  mobile: '',
  groupid: [], // 路由权限ID
  partnershipid: '', // 医联体ID
  hospitalid: '', // 医院ID
  doctype: '', // 账号类型
  typeName: '',
  roleName: '',
  showai: '', // 是否显示ai功能
  canedit: '', // 审核后是否可以编辑
}

const mutations = {
  SET_CODE: (state,code) =>{
      state.code = code
  },
  SET_USERID: (state, userid) => {
    state.userid = userid
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
  SET_MOBILE: (state, mobile) => {
    state.mobile = mobile
  },
  SET_GROUPID: (state, groupid) => {
    state.groupid = groupid
  },
  SER_PARTNERSHIPID: (state, partnershipid) => {
    state.partnershipid = partnershipid
  },
  SET_HOSPITALID: (state, hospitalid) => {
    state.hospitalid = hospitalid
  },
  SET_DOCTYPE: (state, doctype) => {
    state.doctype = doctype
  },
  SET_TYPENAME: (state, typeName) => {
    state.typeName = typeName
  },
  SET_TYPEROLENAME:(state, roleName) => {
    state.roleName = roleName
  },
  SET_SHOWAI:(state, ai) => {
    state.showai = ai
  },
  SET_CANEDIT:(state,canedit) => {
    state.canedit = canedit
  }
}

const actions = {

  // 账号密码登录
  accountPasswordLogin({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      accountPasswordLogin(userInfo).then(response => {
        const { username, userid, mobile } = response.list
        commit('SET_USERNAME', username)
        commit('SET_USERID', userid)
        commit('SET_MOBILE', mobile)
        resolve(response.list)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 验证码登录
  smsCodeLogin({ commit}, userInfo) {
    return new Promise((resolve, reject) => {
      smsCodeLogin(userInfo).then(response => {
        const { username, userid, mobile } = response.list
        commit('SET_USERNAME', username)
        commit('SET_USERID', userid)
        commit('SET_MOBILE', mobile)
        resolve(response.list)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 选择账号类型
  setDocType({ commit,dispatch }, doctorid) {
    return new Promise((resolve, reject) => {
      setDocType(doctorid).then(response => {
        if(response.info == 'ok'){
          const { code,groupid, partnershipid, hospitalid,rightlist, doctype, name,rolename,showai,canedit } = response.list;
          let groupid2 = groupid;
          if(showai == '0'){
            groupid2 = groupid2.replace('210001',"");
          }
          commit('SET_CODE',code)
          commit('SET_GROUPID', groupid2)
          commit('SER_PARTNERSHIPID', partnershipid)
          commit('SET_HOSPITALID', hospitalid)
          commit('SET_DOCTYPE', doctype)
          commit('SET_TYPENAME', name)
          commit('SET_TYPEROLENAME', rolename)
          commit('SET_SHOWAI',showai)
          commit('SET_CANEDIT',canedit)
          // 路由权限
          dispatch('permission/generateRoutes', groupid2, { root: true })
          // 报告权限
          dispatch('permission/setReportPermission', response.list, { root: true })
          // 所有权限
          dispatch('permission/setRights', rightlist, { root: true })    
          
          resolve(response)
  
        }else{
          Message({
            message: response.info,
            type:'error'
         })
         resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 个人中心修改基本信息
  updateUserInfo({ commit }, editInfo) {
    return new Promise((resolve, reject) => {
      updateUserInfo(editInfo).then(response => {
        const newUserName = Vue.prototype.qs.parse(editInfo).username
        commit('SET_USERNAME', newUserName)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 退出账号
  logingout({ commit,dispatch}) {
    return new Promise((resolve, reject) => {
      logingout().then(() => {
        // 清楚个人信息
        commit('SET_CODE','')
        commit('SET_USERNAME', '')
        commit('SET_USERID', '')
        commit('SET_MOBILE', '')
        commit('SET_GROUPID', [])
        commit('SER_PARTNERSHIPID', '')
        commit('SET_HOSPITALID', '')
        commit('SET_DOCTYPE', '')
        commit('SET_TYPENAME', '')
        commit('SET_SHOWAI','')
        // 清除权限
        dispatch('permission/clearPermisson',null,{ root: true})
        window.localStorage.setItem('store', '')
        resolve()
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  clearData({commit,dispatch}){
    // 清除个人信息
    commit('SET_CODE','')
    commit('SET_USERNAME', '')
    commit('SET_USERID', '')
    commit('SET_MOBILE', '')
    commit('SET_GROUPID', [])
    commit('SER_PARTNERSHIPID', '')
    commit('SET_HOSPITALID', '')
    commit('SET_DOCTYPE', '')
    commit('SET_SHOWAI','')
    // 清除权限
    dispatch('permission/clearPermisson',null,{ root: true})

    if(window.localStorage.getItem('store')){
      window.localStorage.setItem('store', '')
    }

    router.push('/login')
  }
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
